import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import App from "./app/app";
import "./i18n/i18n";
import { RootElementId } from "core/constants";
import environment from "@environment";

const el = document.getElementById(RootElementId) as HTMLElement;

const menuAttribute = "data-menu";
const menu = el.getAttribute(menuAttribute) ?? "";

const showMenu: boolean = menu.toString() !== "false";

const root = ReactDOM.createRoot(el);

if (!environment.debuggingEnabled) {
    console.debug = () => { };
}

if (environment.debuggingEnabled && !environment.production) {
    root.render(
        <StrictMode>
            <App hideMenu={!showMenu} />
        </StrictMode>);
} else {
    root.render(<App hideMenu={!showMenu} />);
}

